export default __webpack_public_path__ + "static/media/front.2692d98d.png";